import { render, staticRenderFns } from "./TosModal.vue?vue&type=template&id=7afea255"
import script from "./TosModal.vue?vue&type=script&lang=js"
export * from "./TosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports